module.exports = __webpack_public_path__ + "img/offers-small-light-green.e4d52d5f.svg";